import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const inputVariants = cva(
  "dark:bg-input/30 border-input aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 rounded-lg border bg-transparent transition-colors file:font-medium file:text-foreground placeholder:text-muted-foreground w-full min-w-0 outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive/30 dark:aria-invalid:focus-visible:border-destructive file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        default: "h-8 px-2.5 py-1 text-base md:text-sm file:h-6 file:text-sm",
        xs: "h-6 px-2 py-0.5 text-xs file:h-4 file:text-xs rounded-[min(var(--radius-md),10px)]",
        sm: "h-7 px-2.5 py-0.5 text-sm file:h-5 file:text-xs rounded-[min(var(--radius-md),12px)]",
        lg: "h-9 px-2.5 py-1.5 text-base file:h-6 file:text-sm",
        xl: "h-11 px-3 py-2 text-base file:h-7 file:text-sm rounded-xl",
        "2xl": "h-14 px-4 py-2.5 text-lg file:h-8 file:text-base rounded-2xl",
        "3xl": "h-16 px-5 py-3 text-xl file:h-9 file:text-base rounded-2xl",
        "4xl": "h-20 px-6 py-4 text-2xl file:h-10 file:text-lg rounded-3xl",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

type InputSize = NonNullable<VariantProps<typeof inputVariants>["size"]>;

function Input({
  className,
  type,
  size = "default",
  ...props
}: Omit<React.ComponentProps<"input">, "size"> & { size?: InputSize }) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(inputVariants({ size, className }))}
      {...props}
    />
  );
}

export { Input, inputVariants, type InputSize };
